import { render } from "./SuccessBalancePage.vue?vue&type=template&id=1990e27e"
import script from "./SuccessBalancePage.vue?vue&type=script&lang=js"
export * from "./SuccessBalancePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__